<template>
  <div>
    <table>
      <tr>
        <td>{{ $t('reportHeader.company_name') }}</td>
      </tr>
      <tr>
        <td>{{ $t('reportHeader.company_details') }}</td>
      </tr>
      <tr>
        <td>{{ $t('reportHeader.company_address') }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "ReportHeader"
}
</script>

<style scoped>

</style>
